import Step from '../../step/step'
import { PaymentMethodSelector } from '../../payment-methods-step/components/payment-method-selector'
import { PaymentMethodActionButton } from '../../payment-methods-step/components/payment-method-action-button'
import DonationSummary from './components/donation-summary/donation-summary'
import { Section } from '../section/section'
import useConfig from 'modules/config/state/use-config'
import TermsOfService from '../../shared/terms-of-service'
import { useTranslation } from 'next-i18next'

import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'
import DonorInfo from './components/donor-info/donor-info'
import ContactQuestionsForm from './components/contact-questions-form/contact-questions-form'
import CustomQuestions from './components/custom-questions/custom-questions'
import EmployerMatching from './components/employer-matching/employer-matching'
import PaymentSecureHeader from '../../payment-methods-step/components/payment-secure-header'
import DesignationPreConversionPreview from '../../../../order/components/designation/designation-pre-conversion-preview'
import OrderDonorCoveredFees from 'modules/order/components/donor-covered-fees/standalone-donor-covered-fees'
import OrgDonationOption from './components/donation-options/org-donation-option'
import AnonymousOptionsRow from './components/donation-options/anonymous-options-row'
import { OptInFormField, OptInSmsFormField } from './components/donation-options/opt-in-form-fields'
import { hasRequiredAddressQuestions } from 'modules/config/utils/address-questions-utils'

export default function SingleStep() {
  const { t } = useTranslation()
  const config = useConfig()
  const selectedPaymentMethod = useSelector((state: RootState) => state.order.paymentDetails.type)
  const isBankTransferSelected = selectedPaymentMethod === 'ACH'
  const shouldHideDonorInfo = hasRequiredAddressQuestions(config)

  return (
    <Step.Root header={{ headline: config.organization.name }}>
      <Step.Content>
        <PaymentMethodSelector />
        {/* <DesignationPreConversionPreview /> */}
        {isBankTransferSelected && !shouldHideDonorInfo && (
          <Section title={t('singleStep.donorInformation.title', 'Donor information')}>
            <DonorInfo />
          </Section>
        )}
        {config.payment.corporateDonationEnabled && <OrgDonationOption />}
        <ContactQuestionsForm showRequired />
        <CustomQuestions showRequired />
        <AnonymousOptionsRow />
        {config.optIn.isEnabled && <OptInFormField />}
        {config.optInSms.isEnabled && <OptInSmsFormField />}
        {config.dcf.isEnabled && <OrderDonorCoveredFees />}
        {config.doubleTheDonation.isEnabled && <EmployerMatching />}

        <Section title={t('singleStep.donationSummary.title', 'Donation summary')}>
          <DonationSummary />
        </Section>
      </Step.Content>
      <PaymentMethodActionButton
        fallbackText="Complete Donation"
        dataIdPrefix="single-step-payment-button"
      />
      <PaymentSecureHeader />
      <TermsOfService />
    </Step.Root>
  )
}
